//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LandingHeroAsideWrapper',
  props: {
    bgImage: {
      type: Object,
      default: null,
    },
  },
  computed: {
    backgroundImageUrl() {
      return _.get(this.bgImage, 'previews.jpg.url');
    },
    getBackgroundStyles() {
      if (this.backgroundImageUrl) {
        const url = this.bgImage.previews.jpg.url;
        return `background-image: url('${url}');`;
      }
      return '';
    },
  },
  methods: {
    truncateString(str, len, append) {
      append = append || '';
      if (append.length > 0) append = ` ${append}`;
      if (str.indexOf(' ') + append.length > len) return str;
      const newLength = str.length + append.length > len ? len - append.length : str.length;
      let tempString = str.substring(0, newLength).replace(/\s+\S*$/, '');
      if (append.length > 0) tempString += append;
      return tempString;
    },
  },
};
